import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fakeSessionLogIn, setUserToken } from "../../app/store/auth/authActions";
import { USER_TOKEN } from "../../app/store/auth/authMiddleware";
import QueryString from "qs";

export default function useFakeSession() {
  const dispatch = useDispatch();

  const validSessionToken = (): boolean => {
    const userToken = sessionStorage.getItem(USER_TOKEN);
    if (userToken) {
      const parseUserToken = JSON.parse(userToken);
      if (parseUserToken.sessionToken) {
        const tokenTimeValid = new Date(parseUserToken.tokenValidTo).getTime();
        const actualTime = new Date().getTime();
        if (actualTime <= tokenTimeValid) {
          return false;
        }
      }
    }
    return true;
  };

  useEffect(
    () => {
      if (validSessionToken()) {
        dispatch(fakeSessionLogIn());
      } else {
        const b2bToken = QueryString.parse(window.location.search.slice(1)).B2BSESSION as string;
        if (b2bToken) {
          const userToken = sessionStorage.getItem(USER_TOKEN);
          if (userToken) {
            const parsedUserToken = JSON.parse(userToken);
            const overrideToken = { ...parsedUserToken, sessionToken: b2bToken, userName: b2bToken };
            sessionStorage.setItem(USER_TOKEN, JSON.stringify(overrideToken));
            dispatch(setUserToken(overrideToken));
          }
        }
      }
    }, //eslint-disable-next-line
    []
  );
}
